import { useEffect, useState } from 'react';

const FIELD_SELECTOR = 'input, textarea, select';
/** Écart (px) entre la fenêtre et le viewport visuel au-delà duquel on considère le clavier ouvert. */
const KEYBOARD_THRESHOLD = 150;

const isField = (el: EventTarget | null): boolean => el instanceof Element && el.matches(FIELD_SELECTOR);

/** Détecte l'ouverture du clavier virtuel (visualViewport, avec repli focusin/focusout). */
export function useKeyboardOpen(active: boolean): boolean {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!active) return;

    const vv = window.visualViewport;
    const onResize = (): void => {
      if (vv) setOpen(window.innerHeight - vv.height > KEYBOARD_THRESHOLD);
    };
    const onFocusIn = (e: FocusEvent): void => {
      if (isField(e.target)) setOpen(true);
    };
    const onFocusOut = (): void => {
      // Laisse le temps au focus de passer à un autre champ avant de réafficher la barre.
      window.setTimeout(() => {
        if (!isField(document.activeElement)) setOpen(false);
      }, 100);
    };

    vv?.addEventListener('resize', onResize);
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);
    return () => {
      vv?.removeEventListener('resize', onResize);
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
      setOpen(false);
    };
  }, [active]);

  return active && open;
}
